export enum PoliticallyExposedPersonEnum {
  yes = 'YES',
  no = 'NO',
  closeTo = 'CLOSE_TO'
}
